import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationminibusonrentpune() {



  const cardData = {
"keyword": "Outstation Mini Bus on Rent Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Outstation Mini Bus on Rent Pune service for family vacations, corporate tours, weddings, pilgrimage journeys, school trips, and long-distance group travel. Our well-maintained AC mini buses with professional drivers provide safe, spacious, and comfortable travel for outstation destinations across Maharashtra, Goa, Gujarat, and nearby states at affordable pricing.",

"topPlaces": [

  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba visited by thousands of devotees every day. Mini bus services are ideal for family pilgrimage tours and group temple darshan trips."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is famous for Trimbakeshwar Temple, vineyards, wine tourism, river ghats, and religious importance. Outstation mini bus travel is commonly booked for pilgrimage tours and sightseeing journeys."
  },
  {
    "title": "Goa",
    "description":
      "Goa is one of the top holiday destinations from Pune known for beaches, nightlife, churches, seafood, water sports, resorts, and beach tourism. Friends groups and families frequently book mini buses for Goa road trips."
  },
    {
    "title": "Mumbai",
    "description":
      "Mumbai is one of the most visited outstation destinations from Pune known for Marine Drive, Gateway of India, Juhu Beach, shopping streets, business centers, Bollywood attractions, and nightlife. Families, tourists, and corporate groups frequently hire mini buses for comfortable road travel through the Mumbai Pune Expressway."
  },
  {
    "title": "Lonavala",
    "description":
      "Lonavala is a scenic hill station near Pune famous for waterfalls, green valleys, Bhushi Dam, Tiger Point, caves, and monsoon beauty. Outstation mini bus trips are highly popular for family vacations, corporate outings, and weekend group tours."
  },
  {
    "title": "Khandala",
    "description":
      "Khandala is known for peaceful mountain landscapes, scenic viewpoints, misty valleys, and cool climate. Travelers prefer mini bus rental services for relaxing road trips and group sightseeing tours from Pune."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a popular hill station famous for Venna Lake, strawberry farms, waterfalls, mountain viewpoints, cool weather, and sightseeing attractions. Group travelers frequently choose mini buses for long-distance family vacations."
  },
  {
    "title": "Panchgani",
    "description":
      "Panchgani attracts visitors with Table Land, scenic valleys, boarding schools, fresh air, strawberry farms, and peaceful nature surroundings. Mini bus tours are common for family groups and students."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal destination famous for beaches, sea forts, resorts, water activities, and peaceful beach vacations. Mini buses are widely used for weekend group outings from Pune."
  },
  {
    "title": "Kolhapur",
    "description":
      "Kolhapur is known for Mahalaxmi Temple, historical attractions, shopping markets, and traditional cuisine. Pilgrimage groups and family travelers often prefer mini bus rentals for highway journeys."
  },
  {
    "title": "Ratnagiri",
    "description":
      "Ratnagiri is a beautiful Konkan destination known for beaches, sea views, mango farms, forts, and coastal tourism. Families and tourists commonly hire mini buses for scenic road trips."
  },
  {
    "title": "Tarkarli",
    "description":
      "Tarkarli is famous for clean beaches, scuba diving, snorkeling, seafood, and coastal adventure tourism. Mini bus trips are popular among friends groups and family travelers."
  },
  {
    "title": "Aurangabad",
    "description":
      "Aurangabad is a historic city famous for Ajanta Ellora Caves, Mughal monuments, UNESCO heritage sites, and educational tourism. Mini buses are preferred for sightseeing and student group tours."
  },
  {
    "title": "Bhimashankar",
    "description":
      "Bhimashankar is a sacred Jyotirlinga temple surrounded by forests and hills attracting pilgrims and nature lovers from Pune."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune known for lakeside views, adventure activities, cafes, and scenic landscapes. Corporate outings and family tours frequently use mini bus services."
  },
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is a famous historical fort near Pune known for trekking, mountain views, and Maratha history. Group tourists often choose mini bus travel for day trips and sightseeing."
  },
  {
    "title": "Pawna Lake",
    "description":
      "Pawna Lake is a popular camping and picnic destination offering lakeside camping, bonfires, scenic sunsets, and outdoor adventure activities."
  },
  {
    "title": "Matheran",
    "description":
      "Matheran is a peaceful eco-friendly hill station known for toy train rides, viewpoints, forests, and pollution-free tourism experiences."
  },
  {
    "title": "Kaas Plateau",
    "description":
      "Kaas Plateau is a UNESCO-recognized flower valley famous for seasonal flowers, monsoon beauty, photography, and scenic natural landscapes."
  },
  {
    "title": "Dapoli",
    "description":
      "Dapoli is a Konkan coastal destination known for beaches, dolphin sightseeing, seafood, sea forts, and peaceful tourism experiences ideal for family road trips."
  }
],



services: [
  {
    name: "Mini Bus On Rent in Pune",
    description: "Mini bus on rent in Pune service provides spacious and comfortable transportation for family tours, corporate outings, airport transfers, wedding travel, school trips, and outstation journeys. Well-maintained buses ensure smooth highway travel suitable for local and long-distance group transportation requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Mini Bus Rental Pune",
    description: "Mini bus rental Pune service offers dependable transportation for sightseeing tours, educational trips, family vacations, corporate events, and pilgrimage journeys. Spacious seating and comfortable interiors ensure pleasant travel experiences for all passenger groups. Professional drivers provide safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient mini bus rental reservations."
  },
  {
    name: "AC Mini Bus Hire Pune",
    description: "AC mini bus hire Pune service provides premium air-conditioned transportation for corporate travel, family functions, tourist groups, airport transfers, and outstation journeys. Comfortable seating and cooling systems ensure smooth travel experiences during all seasons. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient AC mini bus reservations."
  },
  {
    name: "Luxury Mini Bus On Rent Pune",
    description: "Luxury mini bus on rent Pune service offers stylish and spacious transportation with premium seating, elegant interiors, and comfortable travel amenities for weddings, VIP travel, corporate events, and group vacations. Luxury buses ensure smooth long-distance journeys suitable for executive and family travel. Professional chauffeurs provide safe driving and dependable transportation services throughout the trip. Pickup services are available from homes, hotels, banquet halls, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury mini bus reservations."
  },
  {
    name: "25 Seater Mini Bus On Rent Pune",
    description: "25 seater mini bus on rent Pune service provides comfortable group transportation for school trips, family functions, corporate events, sightseeing tours, and outstation travel. Spacious seating and luggage space ensure smooth highway journeys suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 25 seater mini bus reservations."
  },
  {
    name: "32 Seater Mini Bus Hire Pune",
    description: "32 seater mini bus hire Pune service offers spacious transportation for large groups, educational tours, wedding travel, company outings, and pilgrimage journeys. Comfortable seating and smooth suspension ensure pleasant travel experiences suitable for long-distance and local group trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, schools, colleges, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient 32 seater mini bus reservations."
  },
  {
    name: "Mini Bus Booking Pune",
    description: "Mini bus booking Pune service provides easy and reliable transportation solutions for local travel, outstation tours, airport transfers, wedding transportation, and business travel requirements. Comfortable buses ensure smooth journeys suitable for tourists, families, and corporate passengers. Professional chauffeurs provide safe driving and dependable transportation services across all major routes. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Cheap Mini Bus On Rent Pune",
    description: "Cheap mini bus on rent Pune service offers economical and comfortable transportation for family trips, educational tours, office outings, and local sightseeing requirements. Spacious vehicles ensure smooth highway travel suitable for affordable group transportation. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient budget mini bus reservations."
  },
  {
    name: "Pune Mini Bus Service",
    description: "Pune mini bus service provides dependable transportation for local travel, airport transfers, corporate employee movement, family functions, and tourist group travel. Comfortable interiors and spacious seating ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services across all major Pune routes. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient mini bus service reservations."
  },
  {
    name: "Outstation Mini Bus On Rent Pune",
    description: "Outstation mini bus on rent Pune service offers reliable long-distance transportation for Goa trips, Mahabaleshwar tours, Shirdi darshan, family vacations, and corporate travel. Spacious buses ensure comfortable seating and smooth highway journeys suitable for tourists and group passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation mini bus reservations."
  },
  {
    name: "Mini Bus for Picnic Pune",
    description: "Mini bus for picnic Pune service provides comfortable transportation for one-day outings, school picnics, family gatherings, corporate day trips, and sightseeing tours. Spacious seating and luggage space ensure pleasant travel experiences suitable for all age groups. Professional drivers ensure safe driving and punctual pickup services throughout the picnic route. Pickup services are available from homes, schools, colleges, offices, hotels, and residential societies across Pune. Flexible booking options allow convenient picnic mini bus reservations."
  },
  {
    name: "Mini Bus for Wedding Pune",
    description: "Mini bus for wedding Pune service offers luxurious and spacious transportation for wedding guests, family members, bridal parties, and marriage function travel requirements. Comfortable seating and stylish interiors ensure smooth journeys suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the event schedule. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient wedding mini bus reservations."
  },
  {
    name: "Mini Bus for Corporate Events Pune",
    description: "Mini bus for corporate events Pune service provides professional transportation for office meetings, conferences, team outings, employee travel, industrial visits, and business functions. Spacious buses ensure comfortable journeys suitable for executive teams and company staff travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate mini bus reservations."
  },
  {
    name: "Mini Bus Hire for School Trip Pune",
    description: "Mini bus hire for school trip Pune service offers safe and reliable transportation for educational tours, school outings, college trips, and student travel requirements. Spacious seating and comfortable interiors ensure smooth journeys suitable for children, teachers, and educational groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the school route. Pickup services are available from schools, colleges, coaching institutes, homes, and educational campuses across Pune. Flexible booking options allow convenient school trip mini bus reservations."
  },
  {
    name: "Tempo Mini Bus On Rent Pune",
    description: "Tempo mini bus on rent Pune service provides economical and spacious transportation for family travel, group tours, airport transfers, local sightseeing, and outstation journeys. Comfortable seating and luggage capacity ensure smooth highway travel suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient tempo mini bus reservations."
  },
  {
    name: "Pune to Goa Mini Bus Rental",
    description: "Pune to Goa mini bus rental service offers premium transportation for beach vacations, tourist travel, corporate outings, family holidays, and bachelor trips from Pune. Spacious buses ensure comfortable overnight journeys with luggage space suitable for long-distance travel. Professional drivers ensure safe highway driving and dependable transportation services throughout the Goa route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Goa mini bus reservations."
  },
  {
    name: "Mini Bus for Group Travel Pune",
    description: "Mini bus for group travel Pune service provides reliable transportation for family vacations, educational tours, pilgrimage trips, office outings, and sightseeing journeys. Spacious seating and smooth highway performance ensure comfortable travel experiences suitable for group passengers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient group travel mini bus reservations."
  },
  {
    name: "Non AC Mini Bus On Rent Pune",
    description: "Non AC mini bus on rent Pune service offers affordable transportation for local travel, educational trips, staff transport, family functions, and short-distance group journeys. Comfortable seating and spacious interiors ensure smooth travel suitable for economical group transportation requirements. Professional drivers ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC mini bus reservations."
  },
  {
    name: "Mini Bus Hire Pune for Family Trip",
    description: "Mini bus hire Pune for family trip service provides spacious and comfortable transportation for holiday vacations, sightseeing tours, religious travel, and weekend getaways. Comfortable seating and luggage space ensure pleasant travel experiences suitable for families and relatives traveling together. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family trip mini bus reservations."
  },
  {
    name: "MiniBus",
    description: "MiniBus service provides dependable and economical transportation for group tours, airport transfers, wedding events, educational travel, corporate outings, and outstation journeys. Spacious interiors and comfortable seating ensure smooth travel experiences suitable for local and long-distance group transportation. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient minibus reservations."
  }
],

tableData: [
  ["Mini Bus On Rent in Pune", "Mini Bus Rental Pune"],
  ["AC Mini Bus Hire Pune", "Luxury Mini Bus On Rent Pune"],
  ["25 Seater Mini Bus On Rent Pune", "32 Seater Mini Bus Hire Pune"],
  ["Mini Bus Booking Pune", "Cheap Mini Bus On Rent Pune"],
  ["Pune Mini Bus Service", "Outstation Mini Bus On Rent Pune"],
  ["Mini Bus for Picnic Pune", "Mini Bus for Wedding Pune"],
  ["Mini Bus for Corporate Events Pune", "Mini Bus Hire for School Trip Pune"],
  ["Tempo Mini Bus On Rent Pune", "Pune to Goa Mini Bus Rental"],
  ["Mini Bus for Group Travel Pune", "Non AC Mini Bus On Rent Pune"],
  ["Mini Bus Hire Pune for Family Trip", "MiniBus"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Outstation Mini Bus on Rent Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable outstation mini bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for family trips, group tours, and long-distance travel."
      },
      {
        WhyChooseheading: "Affordable Outstation Mini Bus Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable outstation mini bus rental packages from Pune with transparent pricing, flexible travel plans, and complete booking assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Outstation Bus Booking Service",
        WhyChoosedescription: "Our outstation mini bus rental service in Pune operates 24 hours for corporate travel, wedding trips, pilgrimage tours, weekend getaways, school outings, and holiday journeys."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Mini Buses",
        WhyChoosedescription: "All mini buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained to provide safe and comfortable outstation travel experiences."
      },
      {
        WhyChooseheading: "Customized One Day & Multi-Day Tours",
        WhyChoosedescription: "Aaradhya Travels offers flexible outstation travel plans including one-day trips, weekend holidays, multi-day tours, and customized travel itineraries according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose mini buses with different seating capacities suitable for family vacations, corporate teams, wedding groups, tourists, and educational trips."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Pune Airport, railway stations, hotels, homes, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our professional drivers are experienced in long-distance highway routes and ensure safe driving, smooth journeys, and timely travel for every outstation trip."
      }
    ]
  };

  const faqData = [
    { question: "What is outstation mini bus on rent Pune?", answer: "Outstation mini bus rental service in Pune provides comfortable group transportation for long-distance travel, family tours, corporate trips, and holiday journeys." },
    { question: "Is outstation mini bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 outstation mini bus rental service from Pune." },
    { question: "Which mini bus seating options are available?", answer: "Aaradhya Travels offers mini buses with multiple seating capacities suitable for small and large group travel requirements." },
    { question: "Can I book mini bus for multi-day outstation tours?", answer: "Yes, customers can book mini buses for one-day trips, weekend travel, and multi-day outstation tours." },
    { question: "Do you provide customized outstation travel packages?", answer: "Yes, Aaradhya Travels provides customized outstation mini bus travel packages according to customer requirements." },
    { question: "Are all mini buses air-conditioned?", answer: "Yes, all mini buses are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book outstation mini bus online in Pune?", answer: "Yes, customers can easily book outstation mini bus rental service online or through phone booking." },
    { question: "Do you provide mini buses for family and corporate tours?", answer: "Yes, Aaradhya Travels provides spacious mini buses suitable for family vacations, corporate travel, and group tours." },
    { question: "Are outstation mini bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for outstation mini bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Jagtap",
    feedback:
      "Our outstation journey from Pune became very comfortable with a mini bus arranged by Aaradhya Travels. The vehicle was clean, spacious, and perfect for long-distance group travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "Aaradhya Travels managed our outstation mini bus on rent in Pune very efficiently. The ride was smooth, the seating was comfortable, and the entire trip felt well organized.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Mini Bus On Rent Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/outstation-mini-bus-rent-pune.jpg",
  "description": "Book Outstation Mini Bus on rent in Pune with Aaradhya Travels for Goa trips, weddings, school tours, corporate events, picnics, and group travel. Affordable AC luxury 25 and 32 seater mini bus rental service available with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2987"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/outstation-mini-bus-on-rent-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Outstation Mini Bus On Rent Pune | AC Luxury Mini Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Outstation Mini Bus on rent in Pune with Aaradhya Travels. Affordable AC luxury 25 and 32 seater mini bus available for Goa trips, picnics, weddings, school tours, corporate events, and group outstation travel."
  />

  <meta
    name="keywords"
    content="Mini Bus On Rent in Pune, Mini Bus Rental Pune, AC Mini Bus Hire Pune, Luxury Mini Bus On Rent Pune, 25 Seater Mini Bus On Rent Pune, 32 Seater Mini Bus Hire Pune, Mini Bus Booking Pune, Cheap Mini Bus On Rent Pune, Pune Mini Bus Service, Outstation Mini Bus On Rent Pune, Mini Bus for Picnic Pune, Mini Bus for Wedding Pune, Mini Bus for Corporate Events Pune, Mini Bus Hire for School Trip Pune, Tempo Mini Bus On Rent Pune, Pune to Goa Mini Bus"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationminibusonrentpune;